import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-1 -1 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M22.5 2.5c11.03 0 20 8.97 20 20s-8.97 20-20 20-20-8.97-20-20 8.97-20 20-20m0-2.5C10.07 0 0 10.07 0 22.5S10.07 45 22.5 45 45 34.93 45 22.5 34.93 0 22.5 0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M22.5 17.74c2.62 0 4.76 2.14 4.76 4.76s-2.14 4.76-4.76 4.76-4.76-2.14-4.76-4.76 2.14-4.76 4.76-4.76m0-2.5c-4.01 0-7.26 3.25-7.26 7.26s3.25 7.26 7.26 7.26 7.26-3.25 7.26-7.26-3.25-7.26-7.26-7.26z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "24.08 6.37 20.92 6.37 19.35 9.1 20.92 11.83 24.08 11.83 25.65 9.1 24.08 6.37"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "24.08 38.63 20.92 38.63 19.35 35.9 20.92 33.17 24.08 33.17 25.65 35.9 24.08 38.63"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "38.63 24.08 38.63 20.92 35.9 19.35 33.17 20.92 33.17 24.08 35.9 25.65 38.63 24.08"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "6.37 24.08 6.37 20.92 9.1 19.35 11.83 20.92 11.83 24.08 9.1 25.65 6.37 24.08"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "28.93 13.84 31.16 16.07 34.2 15.25 35.02 12.21 32.79 9.98 29.75 10.8 28.93 13.84"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "12.21 35.02 9.98 32.79 10.8 29.75 13.84 28.93 16.07 31.16 15.25 34.2 12.21 35.02"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "32.79 35.02 35.02 32.79 34.2 29.75 31.16 28.93 28.93 31.16 29.75 34.2 32.79 35.02"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-fill-secondary",
			points: "9.98 12.21 12.21 9.98 15.25 10.8 16.07 13.84 13.84 16.07 10.8 15.25 9.98 12.21"
		})
	]
});
export default SvgIcon;
